import {
  localeFragment,
  linkBlock
} from './fragments.gql'


export default `query($locale: SiteLocale) {
  globalBanner (${localeFragment}) {
    themeOverride
    globalBannerMessages {
      id
      enabled
      bannerMessage
      mobileBannerMessageLine1
      mobileBannerMessageLine2
      activeFrom
      activeUntil
      hasGlobalPromo
      globalPromo {
        id
        enabled
        activeFrom
        activeUntil
        bannerMessage
        mobileBannerMessage
        pdpMessage
        cartMessage
        cartMessageBeyondHurdle
        promotionIds
        promotionType
      }
      linkedContent {
        ... on DialogRecord {
          slug
          _modelApiKey
        }
        ... on SidebarPageRecord {
          slug
          _modelApiKey
        }
      }
      externalLink
      link {
        ${linkBlock}
      }
    }
  }
}`
